import React from "react"
import { format } from "date-fns"
import TableButton from "core/components/v2/TableButton"
import RecordedProgressMeetViewModel from "../RecordedProgressMeetViewModel"

export default function ProgressMeetSidebar({ lectures, activeIndex, onClick }: any) {
  const { meetingId } = RecordedProgressMeetViewModel()
  return (
    <div className="space-y-2 rounded-lg bg-[#e3e3e3] pb-2 pr-1 shadow-[-1px_1px_3px_0pxr_rgba(132,136,139,0.05)]">
      <p className="px-4 pt-4 text-gray-600 font-inter text-[14px] font-semibold">Past Progress Meeting </p>
      <p className="px-4"> {lectures?.length} Progress Meetings</p>

      <div className="gray-scrollbar flex h-[calc(100vh-300px)] w-full flex-col items-center gap-y-2 overflow-y-auto px-2 pr-1">
        {lectures?.map((item: any, idx: number) => (
          <div
            className={`flex h-[134px] min-h-[134px] w-[calc(100%-32px)] min-w-[205px] flex-col gap-2 rounded-lg border-[0.5px] bg-white p-3 shadow-[-1px_1px_3px_0px_rgba(132,136,139,0.0.05)]`}
          >
            <div className="flex justify-between">
              <h3 className="w-4/5 text-sm font-semibold text-[#333]" title={item?.chapter_name}>
                {item?.chapter_name?.slice(0, 20)}...
              </h3>
            </div>
            <p> Date: {format(item?.session_timestamp * 1000, "do MMM yyyy")}</p>
            <div className="flex-grow"></div>
            <div className="mt-auto flex">
              <TableButton
                outlined
                onClick={() => onClick(item, idx)}
                className={`${item.meeting_id === meetingId && "border-[#07B42D] text-[#07B42D]"}`}
              >
                {item.meeting_id === meetingId ? "Selected" : "Play Video"}
              </TableButton>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
